@if (loading()) {
  <div class="loader">
    <div class="loader__overlay"></div>
  </div>
}
